import palette from '../palette';

export default {
  colorPrimary: {
    backgroundColor: palette.white,
  },
};
